import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardRoute } from "@/lib/policy/route-guard";
import { PlatformTeamCard } from "./-components/platform-team-card";

export const Route = createFileRoute("/_authenticated/platform_/team")({
  beforeLoad: ({ context }) => guardRoute(context.me, "platform-team"),
  component: PlatformTeam,
});

/** Abby's front door: who is on the platform team, and with which role. */
function PlatformTeam() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Platform team"
        meta="People AI's own staff. Admins run the platform; support looks without changing anything."
      />
      <PlatformTeamCard />
    </div>
  );
}
